/**
 * Deterministic, non-cryptographic hash of a string (djb2 variant).
 *
 * Used to derive a stable, short, URL-safe identifier from the maintenance
 * message text so the dismissal cookie key changes whenever the message
 * changes. This guarantees a previously-dismissed user will see a NEW
 * maintenance message even though they hid the previous one.
 */
export function getMessageHash(message: string): string {
  let hash = 5381;
  for (let i = 0; i < message.length; i++) {
    hash = (hash * 33) ^ message.charCodeAt(i);
  }
  return (hash >>> 0).toString(36);
}
